// extracted by mini-css-extract-plugin
module.exports =  {"item":"a10a3f92e9--item--_szzM","image":"a10a3f92e9--image--wxBS6","content":"a10a3f92e9--content--Koa7N"};